import * as React from 'react';
import Section from '../section/Section';

import './style.css';
import '../../assets/style.css';

import logo from '../../assets/graf/hpdlogo.png'
import { LocationOn, Mail, Phone } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import {isBrowser, isMobile } from 'react-device-detect'

import phone from '../../assets/graf/phone_mini.png';
import typewriter from '../../assets/graf/type_mini.png';

export default function Footer(){
    return( !isMobile?<div id="footer" className="background-transparent">
            <Section 
            content={
                <>
            <div className="flex-row flex-centered" style={{width:"100%", fontSize:"1.1rem", gap:"20%", textAlign:"left", alignItems:"space-between"}}>
            <div style={{padding:"3rem", paddingTop:"0", width:"100%"}}>
                <Link to="https://psihologija.hr"><img className="logo" src={logo}/></Link>
                <div style={{fontSize:isMobile?"0.8rem":"1.4rem", padding:"1.2rem"}}>
                    <p>Organizator: <Link style={{color:"#2ccee3"}}  to="https://psihologija.hr">Hrvatsko psihološko društvo</Link></p>
		    <p>Surganizator: <Link style={{color:"#2ccee3"}}  to="https://www.psiholoska-komora.hr/">Hrvatska psihološka komora</Link></p>
                <p style={{fontSize:isMobile?"0.7rem":"1.4rem", }}>Tehnički organizatori: <Link style={{color:"#2ccee3"}} to="https://www.vivid-original.com/">VIVID Original d.o.o.</Link> i Ars Intellectus, obrt za računalno programiranje</p>
                <p style={{fontSize:"1rem", paddingTop:"1rem"}}>2026 @ Hrvatsko psihološko društvo. Sva prava pridržana</p>
            </div>
            </div>
            <div className='flex-row' style={{fontSize:isMobile?"0.8rem":"1.4rem", padding:"3rem",gap:"5rem" }}>
            <div className='flex-column' style={{gap:"1rem"}}>
                    <h2 style={{fontFamily:'Aboreto Regular', color:"#FE2608"}}>KONTAKT</h2>
                    <div className='flex-row' style={{alignItems:'center', gap:"1rem", fontSize:"1.1rem"}}>Tel.<p>+385912312733</p></div>
                    <div className='flex-row' style={{alignItems:'center', gap:"1rem", fontSize:"1.1rem"}}>E-Mail <p>konferencija2026@psihologija.hr</p></div>
                </div>
                <div className='flex-column'  style={{gap:"1rem"}}>
                <h2 style={{fontFamily:'Aboreto Regular', color:"#FE2608"}}>ADRESA</h2>
                <div style={{fontSize:"1.1rem"}}>
                    <p>Hrvatsko psihološko društvo</p>
                    <p>Baburičina 15, 10020 Zagreb</p>
                </div>
                </div>
                
                </div>
            </div>
            
            
            </>
             
            }/>
            .</div>:
            <div id="footer" className="background-transparent">
            <Section 
            content={
                <>
                <Link to="https://psihologija.hr"><img className="logo" src={logo}/></Link>
                <div className='flex-column' style={{fontSize:isMobile?"0.8rem":"1.4rem", padding:"3rem",gap:"2rem" }}>
            <div className='flex-column' style={{gap:"1rem"}}>
                    <h2 style={{fontFamily:'Aboreto Regular', color:"#FE2608"}}>KONTAKT</h2>
                    <div className='flex-row' style={{alignItems:'center', gap:"1rem", fontSize:"0.8rem"}}>Tel.<p>+385912312733</p></div>
                    <div className='flex-row' style={{alignItems:'center', gap:"1rem", fontSize:"0.8rem"}}>E-Mail <p>konferencija2026@psihologija.hr</p></div>
                </div>
                <div className='flex-column'  style={{gap:"1rem"}}>
                <h2 style={{fontFamily:'Aboreto Regular', color:"#FE2608"}}>ADRESA</h2>
                <div style={{fontSize:"0.8rem", textAlign:"left"}}>
                    <p>Hrvatsko psihološko društvo</p>
                    <p>Baburičina 15, 10020 Zagreb</p>
                </div>
                </div>
                
                </div>
            <div className="flex-column flex-centered" style={{width:"100%", fontSize:"0.8rem", gap:"20%", textAlign:"left", alignItems:"space-between"}}>
            <div style={{padding:"1rem", paddingTop:"0", width:"100%"}}>
                
                <div style={{fontSize:isMobile?"0.8rem":"1.4rem"}}>
                    <p>Organizator: <Link style={{color:"#2ccee3"}}  to="https://psihologija.hr">Hrvatsko psihološko društvo</Link></p>
		    <p>Suorganizator: <Link style={{color:"#2ccee3"}}  to="https://www.psiholoska-komora.hr/">Hrvatska psihološka komora</Link></p>
                <p style={{fontSize:isMobile?"0.8rem":"1.4rem", }}>Tehnički organizatori: <Link style={{color:"#2ccee3"}} to="https://www.vivid-original.com/">VIVID Original d.o.o.</Link><br></br> i Ars Intellectus, obrt za računalno programiranje</p>
                <p style={{fontSize:"0.8rem", paddingTop:"1rem"}}>2026 @ Hrvatsko psihološko društvo. Sva prava pridržana</p>
            </div>
            </div>
            </div>
            
            
            </>
            
            }/>
            .</div>
        
    )   
}
